import * as moment from 'moment';
import { Icon, IconText, Link, icons } from '../../../generic';
import styles from './ImportedProjectRow.module.less';
import type { Repository } from '../../../../types';
import RowTitle from './RowTitle';

type UnimportedProjectRowProps = {
  repo: Repository;
};

const ImportedProjectRow = ({ repo }: UnimportedProjectRowProps) => {
  let updatedAt = '';
  if (repo.updated) {
    updatedAt = moment(repo.updated).fromNow();
  } else if (repo.updated_at) {
    updatedAt = moment(repo.updated_at).fromNow();
  }
  return (
    <div className={styles.row}>
      <span className={styles.checkbox}>
        <Link to={repo.url as string} openInNewTab>
          <Icon icon={icons.externalLink} />
        </Link>
      </span>
      <RowTitle repo={repo} />
      <span className={styles.branch}>
        {repo.branch &&
          <IconText
            icon={icons.codeBranch}
            text={repo.branch}
          />}
      </span>
      <span className={styles.status}>
        <IconText
          icon={icons.check}
          text={updatedAt}
        />
      </span>
    </div>
  );
};

export default ImportedProjectRow;
